export default __webpack_public_path__ + "static/media/58t.c921b81b.jpg";